//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from 'owa-graph-schema';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { BookingServiceFragmentFragmentDoc } from '../../fragments/__generated__/BookingServiceFragment.interface';
export type GetBookingServiceQueryVariables = Types.Exact<{
    businessId?: Types.InputMaybe<Types.Scalars['String']>;
    serviceId?: Types.InputMaybe<Types.Scalars['String']>;
}>;
export type GetBookingServiceQuery = {
    __typename?: 'Query';
    getBookingService?: {
        __typename?: 'GetBookingServiceResponse';
        service?: {
            __typename?: 'BookingService';
            title?: string | null;
            description?: string | null;
            notes?: string | null;
            serviceType?: Types.BookingServiceType | null;
            defaultDuration?: string | null;
            preBuffer?: string | null;
            postBuffer?: string | null;
            staffMemberIds?: Array<string | null> | null;
            currencyIsoSymbol?: string | null;
            currencySymbol?: string | null;
            defaultPriceType?: Types.BookingServiceDefaultPriceType | null;
            smsNotificationsEnabled?: boolean | null;
            isLocationOnline?: boolean | null;
            isWebrtcOnlineMeetingEnabled?: boolean | null;
            webUrl?: string | null;
            defaultPrice?: number | null;
            serviceId?: string | null;
            additionalInfo?: string | null;
            bookingServiceCategory?: Types.BookingServiceCategory | null;
            bookingMultiStaffSupportEnabled?: boolean | null;
            bookingServiceLanguage?: string | null;
            isHiddenFromCustomers?: boolean | null;
            maximumAttendeesCount?: number | null;
            canCustomerManageTheirBooking?: boolean | null;
            isPrivate?: boolean | null;
            categoryNames?: Array<string | null> | null;
            defaultLocation?: {
                __typename?: 'BookingLocation';
                displayName?: string | null;
                address?: {
                    __typename?: 'BookingPostalAddress';
                    name?: string | null;
                    street?: string | null;
                    city?: string | null;
                    state?: string | null;
                    countryOrRegion?: string | null;
                    postalCode?: string | null;
                    postOfficeBox?: string | null;
                    locationSource?: Types.BookingLocationSourceType | null;
                    type?: string | null;
                } | null;
                coordinates?: {
                    __typename?: 'BookingLocationCoordinates';
                    accuracy?: number | null;
                    altitude?: number | null;
                    altitudeAccuracy?: number | null;
                    latitude?: number | null;
                    longitude?: number | null;
                } | null;
            } | null;
            customQuestions?: Array<{
                __typename?: 'BookingQuestionAssignment';
                required?: boolean | null;
                questionGuid?: string | null;
            } | null> | null;
            staffGroups?: Array<{
                __typename?: 'BookingServiceStaffGroup';
                staffGroupGuid?: string | null;
                staffList?: Array<string | null> | null;
            } | null> | null;
            bookingServiceFormInfos?: Array<{
                __typename?: 'BookingServiceFormInfo';
                formId?: string | null;
                formName?: string | null;
            } | null> | null;
            bookingsSchedulingPolicy?: {
                __typename?: 'BookingSchedulingPolicy';
                allowStaffSelection?: boolean | null;
                maximumAdvance?: string | null;
                minimumLeadTime?: string | null;
                sendConfirmationsToOwner?: boolean | null;
                sendMeetingInviteToCustomer?: boolean | null;
                timeSlotInterval?: string | null;
                hasCustomServiceWindows?: boolean | null;
                bookingServiceWindows?: Array<{
                    __typename?: 'BookingServiceWindow';
                    startDate?: string | null;
                    endDate?: string | null;
                    bookableHours?: Array<{
                        __typename?: 'BookingWorkHours';
                        day?: string | null;
                        timeSlots?: Array<{
                            __typename?: 'BookingsWorkTimeSlot';
                            start?: number | null;
                            end?: number | null;
                        } | null> | null;
                    } | null> | null;
                } | null> | null;
            } | null;
            bookingsCustomerInformationRequirements?: {
                __typename?: 'BookingCustomerInformationRequirements';
                address?: Types.BookingRequirementLevel | null;
                name?: Types.BookingRequirementLevel | null;
                phone?: Types.BookingRequirementLevel | null;
                notes?: Types.BookingRequirementLevel | null;
                email?: Types.BookingRequirementLevel | null;
                guestEmails?: Types.BookingRequirementLevel | null;
            } | null;
            emailReminders?: Array<{
                __typename?: 'BookingServiceEmailReminder';
                id?: string | null;
                reminderOffset?: string | null;
                message?: string | null;
                isOrganizerReminder?: boolean | null;
                occurrenceChange?: Types.BookingEmailReminderChangeType | null;
                sendOption?: Types.BookingServiceEmailReminderSendOption | null;
                richTextMessage?: string | null;
            } | null> | null;
            bookingUrlCodes?: Array<{
                __typename?: 'BookingUrlCodesEntry';
                key?: string | null;
                value?: {
                    __typename?: 'BookingUrlInfo';
                    isSingleUse?: boolean | null;
                    totalNumberOfBookings?: number | null;
                    bookable?: boolean | null;
                    expirationDateUtc?: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export const GetBookingServiceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetBookingService' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'businessId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'serviceId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'getBookingService' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'request' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'businessId' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'businessId' },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'serviceId' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'serviceId' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'service' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'BookingServiceFragment',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingServiceFragmentFragmentDoc.definitions,
    ],
} as unknown as DocumentNode<GetBookingServiceQuery, GetBookingServiceQueryVariables>;
